import React from 'react';
import { WixDesignSystemProvider } from '@wix/design-system';

export const WDSWithColorBranding: React.FC = ({ children }) => {
  return <WixDesignSystemProvider features={{ newColorsBranding: true }}>{children}</WixDesignSystemProvider>;
};
